export default __webpack_public_path__ + "static/media/help_dox.41c8ad25.png";